import * as React from 'react';
import { Breadcrumb, Button, Row, Col } from 'antd';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { PolicyRuleDataService } from 'src/app/bookings/policy-rules/policy-rule-form.data';
import { PolicyRuleListController } from 'src/app/bookings/policy-rules/list/policy-rule-list.controller';
import { PolicyRuleFormController } from 'src/app/bookings/policy-rules/form/policy-rule-form.controller';
import { ZuluIcon } from 'src/app/shared/icon';

interface Props {
	policyRuleOwner: PolicyRuleOwner;
	rulesSections: string[];
	title: string;
	save: () => Promise<void>;
	cancel: () => void;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	policyRuleDataService: PolicyRuleDataService;
	breadcrumb: any[];
	goToCard: (text: any, key: string, model: PolicyRuleItem) => void;
	setBusy: (isBusy: boolean) => void;
}

@observer
export class GenericPolicyFormView extends React.Component<Props, {}> {
	@autobind
	private renderBreadcrumbItem(route: any): React.ReactNode {
		return (
			<Button
				style={{ height: '100%' }}
				key={route.text}
				onClick={() => route.onClick(route.text)}>
				{route.text}
			</Button>
		);
	}

	private renderBreadcrumb(): React.ReactNode {
		const { breadcrumb } = this.props;
		if (breadcrumb == null || breadcrumb.length < 2) {
			return null;
		}

		return (
			<div className="card header">
				<Row>
					<Col xs={24}>
						<Breadcrumb
							className="m-1"
							separator={<ZuluIcon type="right" />}
							itemRender={this.renderBreadcrumbItem}
							routes={breadcrumb.slice()}
						/>
					</Col>
				</Row>
			</div>
		);
	}

	private renderMainView(): React.ReactNode {
		const {
			policyRuleDataService, policyRuleOwner, rulesSections,
			mode, goToCard, setBusy, children
		} = this.props;

		return (
			<div className="card p-3">
				<Row gutter={16}>
					<Col xs={24} md={8}>
						<CardController
							icon="book"
							className="card-borderless"
							title="General information"
							mode={mode}>
							{children}
						</CardController>
					</Col>
					<Col xs={24} md={16}>
						<PolicyRuleListController
							dataService={policyRuleDataService}
							policyRuleOwner={policyRuleOwner}
							mode={mode}
							sections={rulesSections}
							setBusy={setBusy}
							goToCard={goToCard}
						/>
					</Col>
				</Row>
			</div>
		);
	}

	private renderPolicyRule(rule: PolicyRuleItem): React.ReactNode {
		const { mode, setBusy, rulesSections } = this.props;

		return (
			<Row>
				<Col xs={24}>
					<PolicyRuleFormController
						sections={rulesSections}
						model={rule}
						mode={mode}
						setBusy={setBusy}
					/>
				</Col>
			</Row>
		);
	}

	render(): React.ReactNode {
		const {
			breadcrumb, title, save, cancel,
			mode, onModeChange
		} = this.props;

		let body: any;
		if (breadcrumb != null && breadcrumb.length > 1) {
			const model = breadcrumb[breadcrumb.length - 1].item;
			body = this.renderPolicyRule(model as PolicyRuleItem);
		} else {
			body = this.renderMainView();
		}

		return (
			<div className="window window-normal">
				<Row>
					<Col xs={24} xl={{ offset: 4, span: 16 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={title}
									mode={mode}
									onModeChanged={onModeChange}
									save={save}
									cancel={cancel}
									contextService={this.props.policyRuleDataService}
								/>
							</Col>
						</Row>
						{this.renderBreadcrumb()}
						{body}
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policies/generic-policy-form.view.tsx